import type {
    OnSelectCompanyAttributeOption,
    SelectedFilters,
} from '@/hooks/filters/useCompanyAttributesFilters';

interface SelectedValueIdsParams {
    attribute: OnSelectCompanyAttributeOption['attribute'];
    filters: SelectedFilters;
}

export const resolveSelectedValueIds = ({
    attribute,
    filters,
}: SelectedValueIdsParams): string[] => {
    const filterKey = Object.entries(filters).find(([, filterValues]) =>
        filterValues.some((filterValue) =>
            attribute.values?.some((value) => value.id === filterValue.id),
        ),
    )?.[0];

    if (!filterKey) {
        return [];
    }

    const isCustomAttribute = filterKey === 'customAttributes';
    const ownValueIds = new Set((attribute.values ?? []).map((value) => value.id));

    return (filters[filterKey] ?? [])
        .map((filterValue) => filterValue.id)
        .filter(
            (id): id is string => id !== undefined && (!isCustomAttribute || ownValueIds.has(id)),
        );
};
